import types from '../types';

/**
 * @param {string} id
 * @param {types.CheckBoxOrRadioOption[]} options
 * @returns {types.CheckBoxOrRadioOption[]}
 */
const getOptionsState = (options, id) => {
    if (!options || !Array.isArray(options) || !options.length) {
        throw new Error('Options are missing!');
    }

    return options.map(option => {
        if (option.id == id || option.value == id) {
            return {
                ...option,
                checked: true
            };
        }

        return {
            ...option,
            checked: false
        };
    });
};

/**
 * @param {string} filterId
 * @param {string} filterOptionId
 * @returns {types.Filter[]}
 */
const getFiltersNextStateForSingleCategoryDocs = (
    filters,
    filterId,
    filterOptionId
) =>
    filters.map(filter => {
        if (filter.id === filterId) {
            const options = getOptionsState(filter.options, filterOptionId);

            return {
                ...filter,
                options
            };
        }

        return filter;
    });

export default getFiltersNextStateForSingleCategoryDocs;
